module.exports = __webpack_public_path__ + "img/En-T200-T600.d2e0f4ff.gif";